declare global {
  interface Window {
    google?: any;
  }
}

let scriptPromise: Promise<void> | null = null;

function loadGoogleScript(): Promise<void> {
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    if (window.google?.accounts?.oauth2) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('No se pudo cargar Google Identity Services.'));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

export async function getGoogleAccessToken(clientId: string): Promise<string> {
  if (!clientId) {
    throw new Error('Falta configurar VITE_GOOGLE_CLIENT_ID');
  }

  await loadGoogleScript();

  return new Promise((resolve, reject) => {
    const tokenClient = window.google?.accounts?.oauth2?.initTokenClient?.({
      client_id: clientId,
      scope: 'openid email profile',
      callback: (response: any) => {
        if (response?.error || !response?.access_token) {
          reject(new Error('No fue posible obtener el token de Google.'));
          return;
        }
        resolve(response.access_token as string);
      },
    });

    if (!tokenClient) {
      reject(new Error('Google Identity Services no esta disponible.'));
      return;
    }

    tokenClient.requestAccessToken({ prompt: 'consent' });
  });
}
